import React, { useRef, useState } from 'react'
import { FieldBtn, SearchBorder } from '../dues.style'
import { Checkbox, CrossIcon, IconButton, Pane, Spinner} from 'evergreen-ui'
import { AppInputFieldTransparent } from '../../../../../widget/styledComponents/input_field.style'
import { TableBodyRow } from '../../../../../widget/styledComponents/table.style'
import { gql, useQuery } from '@apollo/client'
import Cookies from 'js-cookie';
import AddDuesFilterButton from './addDuesFilterButton'



export const PROPERTYSEARCHBYRESIDENT= gql`
query Properties_searchByAddressAndResidentName($searchTerm: String!, $facilityId: ID!) {
  properties_searchByAddressAndResidentName(searchTerm: $searchTerm, facilityId: $facilityId) {
    _id
    facility
    type
    address
    numberOfRooms
    squareMeter
    createdAt
    owner {
      _id
      id
      email
      name
      phone
      photo
      facility
      isAccountActivated
      savedCards {
        _id
        expMonth
        maskedPan
        expYear
        isPrimary
      }
      createdAt
    }
    resident {
      _id
      email
      name
      phone
      photo
      facility
      savedCards {
        _id
        expMonth
        maskedPan
        expYear
        isPrimary
      }
      id
      isAccountActivated
      createdAt
    }
    tags {
      name
      value
    }
  }
}
`;

export default function DuesSearchByResidentOrAddress() {

    const [searchText, setSearchText] = useState(null);
    const [show, setShow] = useState(false);

    const handleInputChange = (event) => {
        setShow(false)
    };

    const searchTextRef = useRef(null);

    const handleSearch= ()=>{
        setShow(true)
        setSearchText(searchTextRef.current.value)
    }

const handleInputChangeremove = (index) => {
    const newIndexedValueData = [...selectedIndexData]
    newIndexedValueData.splice(index, 1); 
    setSelectedIndexData(newIndexedValueData)
}

const [selectedIndexData, setSelectedIndexData] = useState([]);
const handleSelectionChange = (option) => {
    const newIndexedValueData = [...selectedIndexData]
    newIndexedValueData.push(option)
    console.log("pABLO00000-===",option)
    console.log(newIndexedValueData.length)
    setSelectedIndexData(newIndexedValueData)
};
    

  return (
    <div>
        {selectedIndexData.length ===0
            ?<p></p>
            : <div><SearchBorder>
                <table className='mt-16'>
                    <tbody>
                    {selectedIndexData && selectedIndexData.map((data,index) => 
                        <TableBodyRow
                        >
                            
                            <td>{data.address}</td>
                            <td>{ data.resident !=null
                                ?data.resident.name
                                :data.owner != null
                                    ?data.owner.name
                                    :'--'
                            }</td>
                            <td>{data.resident != null
                                    ?'Resident/':''
                                }
                                {data.owner !=null?'Owner':''}</td>
                            <td>
                                <IconButton
                                onClick={(e) => handleInputChangeremove(index) }
                                icon={CrossIcon} intent="danger" />
                            </td>
                        </TableBodyRow>
                        )
                    }
                    </tbody>
                </table>
            </SearchBorder>
            
            <br/><br/>

            <AddDuesFilterButton properties={selectedIndexData.map(obj => obj._id)}  /> 

            </div>
            
        }

        <SearchBorder>
            <Pane display="flex" flexDirection="row" justifyContent="space-between">
                <AppInputFieldTransparent
                    type="text"
                    placeholder="Type resident or address to select properties"
                    onChange={handleInputChange}
                    ref={searchTextRef}
                    style={{
                        margin:"5px 10px 0px 0px"
                    }}
                /> 
                <FieldBtn  class="waves-effect waves-light btn-flat "
                    style={{
                    margin:"2.5px 5px 0px 0px"
                    }}
                    onClick={handleSearch}
                >
                    Search
                </FieldBtn>
            </Pane>
        </SearchBorder>
        
        {show &&
            <SearchByResidentOrAddressBody searchText={searchText} onSelectionChanged={handleSelectionChange}  />
        }


        
  

    </div>
  )
}




const SearchByResidentOrAddressBody = ({ searchText, onSelectionChanged }) => {
const facilityId = Cookies.get('facilityId');
const { loading, error, data } = useQuery(PROPERTYSEARCHBYRESIDENT, {
    variables: { 
        searchTerm: searchText,
        facilityId: facilityId
    },
});
const handleSelectionChange = (option) => {
    onSelectionChanged(option)
    console.log("pABLO-===",option)
};

if(error) return <p>Error: {error}</p>
if(loading) return  <Spinner/>
const datat =data.properties_searchByAddressAndResidentName;
console.log(datat)

  return (
    <div>
        
        {data && datat.length>0     &&
            
            <SearchResult initialValues={datat}  onSelectionChange={handleSelectionChange} />
        }
        
    </div>
  )
}




const SearchResult = ({ initialValues, onSelectionChange }) => {
// const initialValues = initialValues
const [values] = useState(initialValues);
const [selectedIndex, setSelectedIndex] = useState([]);
const [selectedIndexData, setSelectedIndexData] = useState([]);



const handleInputChange = (index) => {
    const newIndexedValue = [...selectedIndex]
    const newIndexedValueData = [...selectedIndexData]
    if(newIndexedValue.includes(index)){
        let indx = newIndexedValue.indexOf(index);
        console.log("index=".indx)
        newIndexedValue.splice(indx, 1); 
        newIndexedValueData.splice(indx, 1); 
    }else{
        newIndexedValue.push(index)
        newIndexedValueData.push(values[index])
    }
    setSelectedIndex(newIndexedValue)
    setSelectedIndexData(newIndexedValueData)
    onSelectionChange(values[index])

};
  return (
    <div>
         <SearchBorder>

        <table>
            <tbody>
            {values && values.map((data,index) => 
                <TableBodyRow
                >
                    <td>
                        <Checkbox
                            label=""
                            checked={selectedIndex.includes(index)}
                            onChange={(e) => handleInputChange(index)}
                        />
                    </td>
                    <td>{data.address}</td>
                    <td>{ data.resident !=null
                        ?data.resident.name
                        :data.owner != null
                            ?data.owner.name
                            :'--'
                    }</td>
                    <td>{data.resident != null
                            ?'Resident/':''
                        }
                        {data.owner !=null?'Owner':''}</td>
                </TableBodyRow>
                )
            }
            </tbody>
        </table>
        </SearchBorder>
        

        
    </div>
  )
}




